import React, { useCallback, useEffect, useRef } from 'react';
import { useHistory } from 'react-router';
import { Popup } from 'cd-eft/components/common/Popup';
import { mdiExitToApp } from '@mdi/js';
import { observer } from 'mobx-react';
import { UserLeavingWarningVM, IPopupComponentProps } from './UserLeavingWarningVM';

function UserLeavingWarningComponent(props: IPopupComponentProps) {
  const vm = useRef(new UserLeavingWarningVM(props)).current;
  const { when, section, onOK, okText, onCancel, cancelText, onAction, actionText, text } = props;
  const history = useHistory();

  useEffect(() => {
    let unblock; // To store the unblock function
    
    if (when) {
      unblock = history.block((prompt) => {
        vm.setCurrentPath(prompt.pathname);
        vm.setShowPrompt(true);
        return 'true'; 
      });
    }

    return () => {
      if (unblock) {
        unblock(); 
      }
    };
  }, [history, when]);

  const doActionAndHidePopup = async (action) => {
    if (action) {
      const canRoute = await Promise.resolve(action());
      // if action from props returns FALSE you will stay on current route, else - go to next page
      // console.log('vm.currentPath:', vm.currentPath);
      if (canRoute) {
        history.block(() => { });
        history.push(vm.currentPath);
      }
      vm.setShowPrompt(false);
    }
  };

  const handleOK = useCallback(async () => {
    doActionAndHidePopup(onOK);
  }, [vm.currentPath, history, onOK]);

  const handleCancel = useCallback(async () => {
    doActionAndHidePopup(onCancel);
  }, [vm.currentPath, history, onCancel]);

  const handleAction = useCallback(async () => {
    doActionAndHidePopup(onAction);
  }, [vm.currentPath, history, onAction]);

  return vm.showPrompt ? (
    <Popup
      trigger={when}
      setTrigger={vm.close}
      title={`Leaving ${section}`}
      icon={mdiExitToApp}
      handleOK={handleOK}
      okText={okText ? okText : 'Ok'}
      handleCancel={handleCancel}
      cancelText={cancelText}
      handleAction={handleAction}
      actionText={actionText}
    >
      <p>{text}</p>
    </Popup>
  ) : null;
}

export const UserLeavingWarning = observer(UserLeavingWarningComponent);
